import React from 'react'
import { ZenCartSec } from './zenCartSec'

export const ZenCart = () => {
  return (
    <ZenCartSec />
  )
}
